import { RegisterCorporation } from "../../../module/Login/SignUp"
import { postlogin, urlApiTegra } from "../../../service/api"
import { Login, NewAccount } from "../model"

const url = urlApiTegra

const postLogin = async (data: Login) => {
    return await postlogin(`${url}/login`, data)
}

const postNewAccount = async (data: RegisterCorporation) => {
    return await postlogin(`${url}/register`, data)
}

const postNewPassword = async (data: any) => {
    return await postlogin(`${url}/new_password`, data)
}

const postForgotPassword = async (data: any) => {
    return await postlogin(`${url}/forgot_password`, data)
}

const postResetPassword = async (data: any) => {
    return await postlogin(`${url}/reset_password`, data)
}

export { postLogin, postNewPassword, postForgotPassword, postResetPassword, postNewAccount };